<template>
<div id="puzzle" v-if="puzzle.id">
    <h3>
      <div class="row ">
        <div class="col">
          Puzzle #{{ puzzleId }}
        </div>
        <div class="col" style="text-align: right;">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Download
            </button>
            <div class="dropdown-menu"">
              <a
                class="dropdown-item"
                href="#"
                v-on:click="downloadPuzzle"
                :data-mimetype="mimetype"
                v-for="(mimetype, lbl) in downloadOptions"
                :key="lbl"
              >
                {{ lbl }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </h3>

    <hr />

    <p
      class="alert alert-danger text-center"
      v-if="!puzzle.purchasable_item"
    >
      This puzzle has no purchasable item!
      <!--
      <router-link
        :to="{
          name: 'create_purchasable_item',
          puzzleId: puzzleId
        }"
      >
        Please create one!
      </router-link>
      -->
    </p>

    <puzzle-nav
      :puzzleId="puzzleId"
      :purchasableItemId="puzzle.purchasable_item ? puzzle.purchasable_item.id : null"
    ></puzzle-nav>

    <p
      class="alert alert-danger text-center"
      v-if="violatesSizeCap"
    >
      This puzzle's attachments total over {{ attachmentSizeCap }}MB,
      which prevents the puzzle from being emailed to users.
    </p>

    <!--
    <button v-on:click="renderPuzzle('')">Preview (JPZ)</button>
    <button v-on:click="renderPuzzle('application/x-crossword')">Preview (AcrossLite)</button>

    <div id="rendered-puzzle">
      <div id="grid-cont"></div>
    </div>
    -->

    <h4>
      Puzzle Information
      <span
        class="badge badge-info"
        v-if="puzzle.purchasable"
      >
        Purchasable
      </span>
      <span
        class="badge badge-warning"
        v-if="puzzle.free"
      >
        Free
      </span>
    </h4>

    <table class="table" id="puzzle-info">
      <tr
        class="row"
        v-for="(value, key) in orderedAttrs"
        :key="key"
      >
        <td class="col">
          <span
            v-if="key === 'author'"
          >
            Original File
          </span>

          {{ humanizeAttr(key) }}
        </td>
        <td
          class="col"
          v-if="!hideAttrVals.includes(key)"
        >
          <span
            class="badge badge-secondary"
            v-if="!value"
          >
            {{ `No ${humanizeAttr(key)}` }}
          </span>
          <span
            v-else
          >
            {{ value }}
          </span>
        </td>
        <td
          class="col"
          v-if="key === 'puzzle_contributors'"
        >
          <span
            class="list-group"
            v-if="puzzle.puzzle_contributors.length"
          >
            <router-link
              :to="{
                name: 'author',
                params: {
                  authorId: puzzle_contributor.attributes.contributor.id
                }
              }"
              v-for="puzzle_contributor in puzzle.puzzle_contributors"
              :key="puzzle_contributor.id"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
              {{ puzzle_contributor.attributes.contributor.attributes.name }}
              <span
                class="badge badge-primary"
                v-if="puzzle_contributor.attributes.editor"
              >
                Editor
              </span>
              <span
                class="badge badge-secondary"
                v-if="puzzle_contributor.attributes.author"
              >
                Author
              </span>
            </router-link>
          </span>
          <p
            v-else
            class="alert alert-info text-center"
          >
            No featured contributors
          </p>
        </td>
      </tr>
      <tr
        class="row"
      >
        <td
          class="col"
        >
          Details
        </td>
        <td
          class="col"
        >
          <span
            v-for="(value, key) in orderedBoolAttrs"
            :key="key"
          >
            <span
              class="badge badge-sm badge-primary"
              v-if="value"
            >
              {{ $root.capitalize(key) }}
            </span>
          </span>
        </td>
      </tr>
      <tr class="row">
        <td class="col">
          Tags
        </td>
        <td class="col" v-if="puzzle.tags.length">
          <span
            v-for="tag in puzzle.tags"
            :key="tag.id"
          >
            <router-link
              :to="{
                name: 'tag',
                params: {
                  tagId: tag.id
                }
              }"
              tag="button"
              class="btn btn-primary btn-sm tag"
            >
              {{ tag.attributes.name }}
            </router-link>
          </span>
        </td>
        <td class="col" v-else>
          <span
            class="badge badge-secondary"
          >
            No tags
          </span>
        </td>
      </tr>
      <tr class="row">
        <td class="col">
          Puzzle Type
        </td>
        <td class="col" v-if="puzzle.provider && puzzle.provider.id">
          <router-link
            :to="{
              name: 'provider',
              params: {
                providerId: puzzle.provider.id
              }
            }"
            v-if="puzzle.provider.id"
          >
            {{ puzzle.provider.attributes.title }}
          </router-link>
        </td>
        <td class="col" v-else>
            No puzzle type
        </td>
      </tr>
      <tr
        class="row"
        v-if="puzzle.uploaded_by && puzzle.uploaded_by.id"
      >
        <td class="col">
          Uploaded By
        </td>
        <td class="col">
          <router-link
            :to="{
              name: 'user',
              params: {
                providerId: puzzle.uploaded_by.id
              }
            }"
          >
            {{ puzzle.uploaded_by.attributes.name || puzzle.uploaded_by.attributes.email }}
          </router-link>
        </td>
      </tr>
      <tr
        class="row"
      >
        <td class="col">
          External IDs
        </td>
        <td class="col">
          {{  puzzle.external_ids  }}
        </td>
      </tr>
    </table>

    <hr />

    <h4>
      Puzzle Attachments <span v-html="attachmentSizeBadge"></span>

      <button
        class="btn btn-sm btn-warning"
        @click="regenerate"
        v-if="attachments"
      >
        Regenerate Files
      </button>
    </h4>
      <ul
        class="list-group"
      >
        <li
          class="list-group-item"
          v-for="attachment in puzzle.attachments" :key="attachment.id"
        >
          <a
            href="#"
            :data-attachment-id="attachment.id"
            :data-attachment-mimetype="attachment.mimetype"
            v-on:click.prevent="downloadAttachment"
          >
            {{ attachment.name }}
            <span
              class="badge badge-sm badge-primary"
            >
              {{ Math.ceil(attachment.byte_size / 1024) }}kb
            </span>
            <span
              class="badge badge-sm badge-info"
            >
              {{ $root.displayDateTimeFmt(attachment.updated_at) }}
            </span>

            <span class="badge badge-warning" v-if="attachment.auto_generated">
              Auto-Generated
            </span>
          </a>
        </li>
      </ul>
    <hr />

    <h4>Puzzle Newsletters</h4>

    <paged-newsletters
      :pageItems="newsletters"
      v-if="newsletters"
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <router-link
          :class="$root.listItemClasses"
          :to="{
            name: 'newsletter',
            params: {
              newsletterId: item.id
            }
          }">
          {{ item.subject }} <span class="badge badge-primary">#{{ item.id }}</span>
        </router-link>
      </template>
    </paged-newsletters>
  </div>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import PuzzleNav from '@/components/PuzzleNav'

import AttachmentMixin from '@/mixins/AttachmentMixin'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      attachments: [],
      hideAttrVals: [
        'authors', 'contributors', 'editors', 'puzzle_contributors'
      ],
      newsletters: []
    }
  },

  computed: mapState({
    base: state => state.base,
    newsletter: state => state.NewsletterModule.newsletter,
    puzzle: state => state.PuzzleModule.puzzle,

    dims () {
      return this.puzzle.height + 'x' + this.puzzle.width
    },

    downloadOptions () {
      return {
        'AcrossLite': 'application/x-crossword',
        'iPuz': 'application/x-ipuz',
        'JPZ': 'application/jpz',
        'JPZ Compressed': 'application/zip',
        'JSON': 'application/json',
        'JSON+SVG': 'application/json+svg',
        'PA XML v1': 'application/x-pa-xml-1',
        'PA XML v2': 'application/x-pa-xml',
        'PDF': 'application/pdf',
        'PDF Solution': 'application/pdf_solution',
        'PZL SVG': 'image/svg+xml',
        'YAML': 'application/yaml'
      }
    },

    orderedAttrs () {
      let ordered = {}

      const attrs = [
        'name', 'author', 'puzzle_contributors',
        'notes', 'copyright', 'dims', 'difficulty',
        'date', 'created_at', 'updated_at'
      ]

      for (let attr of attrs) {
        ordered[attr] = this.puzzle[attr] || this[attr]
        if (attr === 'date' || attr.match(/_at$/)) {
          ordered[attr] = this.$root.displayDateTimeFmt(this.puzzle[attr])
        }
      }

      return ordered
    },

    orderedBoolAttrs () {
      let orderedBools = {}
      const attrBools = [
        'cryptic', 'diagramless', 'encrypted', // 'active',
        'locked', 'public', 'arrow'
      ]

      for (let attr of attrBools) {
        orderedBools[attr] = this.puzzle[attr] || this[attr]
      }

      return orderedBools
    },

    puzzleUrl () {
      return '/puzzles/' + this.puzzleId
    },

    types () {
      if (this.puzzle.puzzle_types.length) {
        return this.puzzle_types.join(', ')
      } else {
        return 'US'
      }
    }
  }),

  components: {
    'paged-newsletters': Pagination,
    'puzzle-nav': PuzzleNav
  },

  props: ['puzzleId'],

  mixins: [ AttachmentMixin ],

  mounted () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        `PuzzleModule/getPuzzle`, this.puzzleId
      ).then(() => {
        this.attachments = this.puzzle.attachments
        // Get each newsletter.
        this.puzzle.relationships.newsletters.map((rel) => {
          this.$store.dispatch(
            `NewsletterModule/getNewsletter`, rel.id
          ).then(() => {
            this.newsletters.push(this.newsletter)
            this.allAttachments = this.attachments
          })
        })
      }).catch(this.$root.processErrors)
    },

    downloadAttachment (ev) {
      const target = ev.target
      const mimetype = target.dataset.mimetype

      this.$http.get(this.apiUrl(this.puzzleUrl + '/attachments/' + target.dataset.attachmentId, true), {
        headers: {
          'Accept': mimetype
        },
        responseType: 'blob'
      }).then((response) => {
        let headers = response.headers

        let blob = new Blob([response.bodyBlob], {
          type: headers['Content-Type']
        })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.headers.get('filename')
        link.click()
      }, this.processErrors)
    },

    downloadPuzzle (ev) {
      ev.preventDefault()

      const target = ev.target
      const mimetype = target.dataset.mimetype
      this.$http.get(this.apiUrl(this.puzzleUrl, true), {
        headers: {
          'Accept': mimetype
        },
        responseType: 'blob'
      }).then((response) => {
        let headers = response.headers

        let blob = new Blob([response.bodyBlob], {
          type: headers['Content-Type']
        })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.headers.get('filename')
        link.click()
      }, this.processErrors)
    },

    humanizeAttr (attr) {
      return this.$root.humanize(attr)
    },

    regenerate () {
      this.$store.dispatch(
        `PuzzleModule/regenerateFiles`, this.puzzleId
      ).then(this.get).catch(this.$root.processErrors)
    },

    // This needs to be replaced with PZL Tools.
    renderPuzzle (mimetype) {
      /*
      if (mimetype) {
        this.mimetypes = mimetype
      }

      this.$http.get('/admin/puzzles/' + this.puzzleId, {
        headers: {
          'Accept': this.mimetypes
        }
      }).then((response) => {
        let reader = new FileReader();

        reader.onloadend = function(e) {
          let buf = e.target.result;

          let dataview = new DataView(buf);
          let byteArray = new Uint8Array(buf.byteLength);

          for (var i = 0; i < buf.byteLength; i++) {
            byteArray[i] = dataview.getUint8(i).toString(10);
          }

          // Format switching!
          let XW = undefined
          switch (mimetype) {
            case 'application/x-crossword':
              XW = new AcrossLite
              break
            default:
              XW = new Jpz
          }

          XW.importPuzzle(byteArray);
          let renderer = new Renderer(XW, {
            'main': '#rendered-puzzle'
          });
          renderer.drawPuzzle();
        };

        reader.readAsArrayBuffer(response.body);

      }, (response) => {
        resultsStore.setErrorsState(response.body.errors)
      })
      */
    },

    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}
</script>

<style scoped>
.auto-generated {
  background-color: #F5EB8F
}

main nav ul {
  text-align: center;
}

td {
  width: 40%;
  overflow: hidden;
  overflow-wrap: break-word;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/Puzzle.vue